import { QueryClientConfig, QueryObserverOptions } from '@tanstack/react-query';

/**
 * Default low-traffic options
 */
const clientOptions: Omit<QueryObserverOptions, 'queryKey'> = {
  // Treat SSR-hydrated data as fresh for the page session. Loyalty routes already
  // opt out of passive refetch triggers and use explicit query invalidation after
  // mutations; a finite staleTime schedules metadata-only observer updates that can
  // repaint already-visible dashboard content and move LCP.
  staleTime: Infinity,
  // Cache for 5 minutes
  gcTime: 1000 * 60 * 5,
  // Refetch settings
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchInterval: false,
};
export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: clientOptions,
  },
};
